import {
  APP_SETTING_UPDATE_AI_MODEL_CONFIG_BEGIN,
  APP_SETTING_UPDATE_AI_MODEL_CONFIG_SUCCESS,
  APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE,
  APP_SETTING_UPDATE_AI_MODEL_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateAiModelConfig(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_AI_MODEL_CONFIG_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/ai-model-config`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_UPDATE_AI_MODEL_CONFIG_SUCCESS,
              data: res.data,
            });
            if (res.data.success === false) {
              toast.error(`Failed: ${res.data.message}`, {});
            } else {
              toast.success('Updated Successfully !', {});
            }
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUpdateAiModelConfigError() {
  return {
    type: APP_SETTING_UPDATE_AI_MODEL_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_AI_MODEL_CONFIG_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateAiModelConfigPending: true,
        updateAiModelConfigError: null,
      };

    case APP_SETTING_UPDATE_AI_MODEL_CONFIG_SUCCESS:
      // The request is success
      return {
        ...state,
        updateAiModelConfigPending: false,
        updateAiModelConfigError: null,
        projectDetail: {
          ...state.projectDetail,
          aiModelConfigs: action.data.aiModelConfigs,
        },
      };

    case APP_SETTING_UPDATE_AI_MODEL_CONFIG_FAILURE:
      // The request is failed
      return {
        ...state,
        updateAiModelConfigPending: false,
        updateAiModelConfigError: action.data.error,
      };

    case APP_SETTING_UPDATE_AI_MODEL_CONFIG_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateAiModelConfigError: null,
      };

    default:
      return state;
  }
}
